import * as Yup from "yup";

export const formSchema = Yup.object().shape({
    firstName: Yup.string()
        .required('Imię jest wymagane.')
        .min(2, 'Imię jest za krótkie.')
        .max(50, 'Imię jest za długie.')
        .matches(/^[\p{L} ]+$/gu, 'Podaj prawidłowe imię.'),
    phone: Yup.string()
        .matches(/^[+]?[0-9\s\-\(\)]{9,15}$/, 'Podaj prawidłowy numer telefonu.')
        .required('Numer telefonu jest wymagany.'),
    email: Yup.string()
        .email('Podaj prawidłowy adres email.')
        .max(255, 'Email jest za długi.'),
    selectedCar: Yup.string()
        .required('Wybierz model samochodu.'),
    newsletter_info: Yup.boolean()
        .when('newsletterAgreement', {
            is: true,
            then: (schema) => schema.oneOf([true], 'To pole jest obowiązkowe gdy zaznaczono newsletter'),
            otherwise: (schema) => schema
        }),
    statute: Yup.boolean()
        .when('newsletterAgreement', {
            is: true,
            then: (schema) => schema.oneOf([true], 'To pole jest obowiązkowe gdy zaznaczono newsletter'),
            otherwise: (schema) => schema
        }),
});